import { useState } from 'react';

export function useAcceptDataProcessingTerms() {
  const [accepted, setAccepted] = useState(false);
  return { accepted, setAccepted };
}
